import React, { Component, Fragment } from 'react';
import { extend, sortBy } from 'lodash';
import moment from 'moment';
import {
  RowContainer,
  HorizontalBarSelector,
} from 'scripts/components/shared/FinancialsPanel';
import {
  years as historicalGrowthYears,
  dynamicOptions,
} from 'scripts/constants/HistoricalGrowth';
import { htmlEncoded } from 'scripts/utilities/formatters';
import {
  property as propertyPropType,
  cashRateData as cashRateDataPropType,
} from 'scripts/constants/PropTypes';
import Highchart from 'src/third-party/highchart/Highchart';
import chartConfig from 'scripts/constants/chartConfig';
import chartLineConfig from 'scripts/constants/chartLineConfig';
import moneyOrPercent from 'scripts/utilities/moneyOrPercent';
import { historicalGrowthChartBottom } from 'src/settings/text';

const calculateYearsRange = (data) => {
  if (data && data.length > 0) {
    return moment(data[data.length - 1].date).diff(
      moment(data[0].date),
      'years',
      true
    );
  }
  return 20;
};

const DEFAULT_NOY_SELECTED = (cashRateData) => {
  if (cashRateData) {
    return dynamicOptions(calculateYearsRange(sortBy(cashRateData, 'date')))[0];
  }
  return historicalGrowthYears.TWENTY;
};

export default class HistoricalRBACashRate extends Component {
  static propTypes = {
    property: propertyPropType,
    cashRateData: cashRateDataPropType,
  };

  state = {
    numberOfYearsSelected: DEFAULT_NOY_SELECTED(this.props.cashRateData),
  };

  render() {
    const { cashRateData } = this.props;
    const { numberOfYearsSelected } = this.state;

    const yearsToShow = parseInt(numberOfYearsSelected, 10);
    const endTimestamp =
      cashRateData && cashRateData.length > 0
        ? moment(cashRateData[0].date)
        : moment();
    const startTimestamp = endTimestamp.clone().subtract(yearsToShow, 'years');
    const dataToShow = sortBy(cashRateData, 'date')
      .slice()
      .filter(({ date }) => moment(date).isSameOrAfter(startTimestamp))
      .map(({ date, cashRate }) => ({
        x: moment(date).valueOf(),
        y: cashRate,
      }));

    const chartBottomText = historicalGrowthChartBottom(
      this.props.property.propertyType
    );
    const yOptions = dynamicOptions(
      calculateYearsRange(sortBy(cashRateData, 'date'))
    );

    return (
      <Fragment>
        <RowContainer>
          <HorizontalBarSelector
            options={yOptions}
            selected={numberOfYearsSelected}
            onChange={(selected) =>
              this.setState({ numberOfYearsSelected: selected })
            }
            reverse
          />
        </RowContainer>
        <Highchart
          hotReload
          className="historical-rba-cashrate__highchart"
          config={extend(chartConfig, chartConfig.options, {
            xAxis: { type: 'datetime' },
            tooltip: {
              formatter: function () {
                return `<b>${moment(this.x).format(
                  "MMMM 'YY"
                )}</b>: ${moneyOrPercent(this.y)::htmlEncoded()}`;
              },
            },
            series: [
              extend(chartLineConfig, {
                type: 'areaspline',
                data: dataToShow,
                animation: false,
              }),
            ],
          })}
        />
        <RowContainer>
          <small className="asterisk-info">{chartBottomText}</small>
        </RowContainer>
      </Fragment>
    );
  }
}
